import PropTypes from 'prop-types'

import HomeScreen from 'pages/index'
import PartnersEvents from 'pages/[application]/events'

const SignIn = ({ application, ...props }) => {
  if (application === 'citifyd') {
    return <HomeScreen {...props} />
  }

  return <PartnersEvents {...props} />
}

SignIn.propTypes = {
  application: PropTypes.string,
}

export default SignIn
